var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"dd078f60c4c0c7d88f31b5b705199ad1148a46aa"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["yoco-com@yoco-technologies"]={id:"dd078f60c4c0c7d88f31b5b705199ad1148a46aa"};
      